
import { useLocation } from 'react-router-dom';
import DefaultNavbar from './navbar/Navbar';
import DashboardNav from './navbar/DashboardNav';

const Navbar = () => {
  const location = useLocation();
  
  // Use dashboard nav only on the dashboard page
  if (location.pathname === '/dashboard') {
    return <DashboardNav />;
  }
  
  // Use default navbar for all other pages
  return <DefaultNavbar />;
};

export default Navbar;
